import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LoginButton: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <button style={styles.button} onClick={() => loginWithRedirect()}>
      Get Started for Free
    </button>
  );
};

const LandingPage: React.FC = () => {
  return (
    <div style={styles.container}>
      {/* Header Section */}
      <header style={styles.header}>
        <h1 style={styles.logo}>DocuQuery</h1>
        <LoginButton />
      </header>

      {/* Hero Section */}
      <div style={styles.hero}>
        <div style={styles.textContent}>
          <h2 style={styles.heading}>
            Upload Documents & <span style={styles.highlight}>Ask Anything</span>
          </h2>
          <p style={styles.subheading}>
            Quickly find the information you need from your documents using 
            <b> AI-powered natural language search.</b> Just upload a document, ask a 
            question, and get instant answers.
          </p>
          <p style={styles.ctaText}>It's <i>100% free</i> – start exploring now!</p>
          <LoginButton />
        </div>
        <img
          src="/LandingPagePic.png" // Replace with your own image
          alt="AI document search"
          style={styles.heroImage}
        />
      </div>

      {/* Features Section */}
      <div style={styles.featuresSection}>
        <h3 style={styles.featuresHeading}>Why Use DocuQuery?</h3>
        <div style={styles.featuresContainer}>
          <div style={styles.featureCard}>
            <h4>🔍 Instant Answers</h4>
            <p>Skip the search – ask a question and get precise answers from your documents.</p>
          </div>
          <div style={styles.featureCard}>
            <h4>📄 Any Document</h4>
            <p>Supports PDFs, Word documents, text files, and more.</p>
          </div>
          <div style={styles.featureCard}>
            <h4>🚀 Save Time</h4>
            <p>No more scrolling through long documents. Find what you need instantly.</p>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div style={styles.ctaSection}>
        <h2>Start Finding Answers Today</h2>
        <p>Upload your first document and ask your first question – for free.</p>
        <LoginButton />
      </div>
    </div>
  );
};

/* 🔥 Modern Styling */
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
    backgroundColor: "#f4f7fc",
    minHeight: "100vh",
    color: "#333",
    paddingBottom: "40px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 40px",
    backgroundColor: "#ffffff",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  },
  logo: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#007bff",
  },
  hero: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 20px",
  },
  textContent: {
    maxWidth: "600px",
    textAlign: "left",
    marginRight: "40px",
  },
  heading: {
    fontSize: "42px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  highlight: {
    color: "#007bff",
  },
  subheading: {
    fontSize: "18px",
    lineHeight: "1.6",
    color: "#555",
  },
  ctaText: {
    fontSize: "16px",
    fontWeight: "bold",
    marginTop: "10px",
    color: "#007bff",
  },
  heroImage: {
    width: "600px",
    borderRadius: "10px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
  },
  featuresSection: {
    marginTop: "60px",
    padding: "40px 20px",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    maxWidth: "900px",
    margin: "auto",
    marginBottom: "60px",
  },
  featuresHeading: {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  featuresContainer: {
    display: "flex",
    justifyContent: "space-around",
    textAlign: "left",
  },
  featureCard: {
    maxWidth: "250px",
    padding: "20px",
    backgroundColor: "#f4f7fc",
    borderRadius: "10px",
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
  },
  ctaSection: {
    marginTop: "60px",
    padding: "40px 20px",
    backgroundColor: "#007bff",
    color: "#fff",
    borderRadius: "10px",
    maxWidth: "700px",
    margin: "auto",
    textAlign: "center",
  },
  button: {
    backgroundColor: "#007bff",
    color: "#fff",
    padding: "14px 28px",
    fontSize: "16px",
    fontWeight: "bold",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "0.3s ease-in-out",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    marginTop: "10px",
  },
};

export default LandingPage;
